export default {"src":"/_next/static/media/mask-cover.062a9a3a.svg","height":475,"width":329,"blurWidth":0,"blurHeight":0};